import { useSignal } from "@preact/signals-react"
import { postSubmit } from "@ui-seeker/utils"

import { BACKEND_APIS } from "@constants"
import { useToast, useUserApp } from "@hooks"
import { flashOffersReportDrawerIsOpen } from "../@signals"

export default function useCustomDashboardsPrimorFlashOffersReportForm(dataRow={}) {
    const { showToast } = useToast()
    const { userEmail, userCustomer } = useUserApp()

    const nameReport = useSignal('')
    const emailsReport = useSignal([userEmail])

    const resetFormData = () => {
        nameReport.value = ''
        emailsReport.value = [userEmail]
    }


    const handleOpenForm = () => {
        flashOffersReportDrawerIsOpen.value = true
    }

    const handleSendToBack = () => {
        // ⛔ Se queda en v1 a propósito, y no es deuda: `flashOffer` es el report de Primor, que es
        // `client_type='retailer'` con `has_dipi_access = 0` y vive en RetailersAppKit. Es el único
        // de los 13 tipos que webback v2 NO implementa (decisión del usuario, 2026-08-31), así que
        // no hay `/reports/create` de v2 que sirva a esta pantalla.
        //
        // ⚠️ No confundir con "no tiene reports hoy", que no es razón: `digitalShelf` se dio por
        // muerto en agosto por tener 0 y volvió cuando un usuario creó uno. Este se queda por
        // DÓNDE está el cliente, no por cuántas filas tiene.
        const apiUrl =`${BACKEND_APIS.REPORTS}/create`
        const payload = {
            nameReport: nameReport.value,
            frequency: 'date',
            emailsReport: emailsReport.value.join(","),
            reportType: 'flashOffer',
            conditions: {},
            filters: {}
        }

        showToast.promise(postSubmit(apiUrl, payload), {
            error: 'Error: Please try again later.',
            success: `Report successfully created.`,
        })
    }

    return {
        handleOpenForm,
        handleSendToBack,
        resetFormData,
        nameReport: nameReport,
        emailsReport: emailsReport
    }
}